export default {
    SET_CATEGORIES(state, categories) {
        state.categories = categories.items
        state.totalPages = categories.total_pages
    },
    ADD_CATEGORY(state, category) {
        state.categories.unshift(category)
    },
    UPDATE_CATEGORY(state, category) {
        const categoryIndex = state.categories.findIndex((u) => u.id === category.id)
        Object.assign(state.categories[categoryIndex], category)
    },
    DELETE_CATEGORY(state, categoryId) {
        const ItemIndex = state.categories.findIndex((u) => u.id === categoryId)
        state.categories.splice(ItemIndex, 1)
    },
    ADD_CATEGORY_INFOS(state, category) {
        state.categoryInfos = category
    }
}
